/**
 * Article type utilities
 */

/**
 * Article types that can be refreshed from their source URL.
 * URL articles are refreshed by re-scraping the webpage.
 */
export enum RefreshableArticleType {
  URL = 'URL',
}

/**
 * Check if an article type can be refreshed from its source URL.
 */
export const isRefreshableArticleType = (type: string): type is RefreshableArticleType =>
  Object.values(RefreshableArticleType).includes(type as RefreshableArticleType);
